import React, { useEffect, useState } from "react";
import "./answerQuestionDetails.scss";

import { postAnswerOfQuestion } from "./api/answerQuestionDetailsApi";

import { Button, Form, Stack } from "react-bootstrap";
import { isEmpty } from "../../utils/validation";
import { t } from "i18next";
import { gestioneSnackbar } from "../../utils/common";

const AnswerQuestionDetails = ({
  id,
  image,
  name,
  datetime,
  question,
  answer,
  refreshContent,
}) => {
  const [answerState, setAnswerState] = useState("");

  useEffect(() => {
    setAnswerState("");
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEmpty(answerState))
      return gestioneSnackbar(true, t("validation.mandatory_answer"), "error");

    postAnswerOfQuestion({ answer: answerState, id_user_question: id }).then(
      (res) => {
        gestioneSnackbar(true, res.message, "success");
        setAnswerState("");
        refreshContent();
      }
    );
  };

  return (
    <Stack gap={3} className="w-100">
      {/*Intestazione con nome e congome oppure nome dell'associazione */}
      <Stack direction="horizontal" gap={2}>
        <img src={image} alt="profilo" />
        <Stack className="d-flex align-items-start justify-content-around">
          <span>{name}</span>
          <span className="datetime-span">{datetime}</span>
        </Stack>
      </Stack>

      {/*Corpo della domanda */}
      <p>{question}</p>

      {isEmpty(answer) ? (
        <Form onSubmit={handleSubmit}>
          <Stack gap={2}>
            <Form.Group controlId="answerId" className="w-100">
              <Form.Control
                placeholder={t("answer_question.answer")}
                as="textarea"
                rows={5}
                maxLength={255}
                value={answerState}
                onChange={(e) => setAnswerState(e.target.value)}
              />
            </Form.Group>
            <div className="d-flex justify-content-center">
              <Button
                variant="success"
                type="submit"
                className="w-50 rounded-5"
              >
                {t("answer_question.send_answer")}
              </Button>
            </div>
          </Stack>
        </Form>
      ) : (
        <>
          <hr />
          <p>{answer}</p>
        </>
      )}
    </Stack>
  );
};

export default AnswerQuestionDetails;
